import { zipForm, infoWindowContent, becomeDealerForm } from './custom_forms';
import { alert } from './utils';
import { translations } from "./content/translations";

//let lang = localStorage.getItem("user_language");
let lang = "en";

if (!lang) {
    lang = Object.keys(languages).find((language) => language === navigator.language?.slice(0, 2)) || "en";
    localStorage.setItem("user_language", lang);
}

let dealersData = []
let infoWindow = undefined

const setMarker = (dealer, geocoder, bounds, map) => {
    geocoder.geocode(
        {'address': dealer.address},
        (results, status) => {
            dealer.address = results[0].formatted_address;
            if (status === google.maps.GeocoderStatus.OK) {
                
                const marker = new google.maps.Marker({
                    map: map,
                    position: results[0].geometry.location,
                    title: dealer.name,
                    address: results[0].formatted_address
                })

                bounds.extend(marker.getPosition());
                map.fitBounds(bounds);
                
                marker.addListener("click", () => {
                    if (infoWindow) infoWindow.close();
                    
                    infoWindow = new window.google.maps.InfoWindow({
                        content: infoWindowContent(dealer),
                        ariaLabel: "Uluru",
                    });

                    infoWindow.open({
                        anchor: marker,
                        map,
                    });
                });
            }
        }
    )
}

export const getInputsData = (event) => {
    event.preventDefault();
    const form = document.querySelector("#zipCodeForm")
    const formData = {
        zip: form.zipCode.value,
        country: form.country.value || form.country.placeholder,
        distance: form.distance.value || form.distance.placeholder
    }

    if (formData.zip && formData.country) {
        var service = new google.maps.DistanceMatrixService();
        service.getDistanceMatrix(
            {
                origins: [`${formData.zip} ${formData.country}`],
                destinations: [...dealersData.map(item => item.address)],
                travelMode: google.maps.TravelMode.DRIVING,
                unitSystem: google.maps.UnitSystem.IMPERIAL,
                avoidHighways: false,
                avoidTolls: false,
            }, (response, status) => {
                if (status === google.maps.DistanceMatrixStatus.OK) {
                    if (response.rows.length) {
                        response.rows[0].elements.forEach((item, index) => {
                            if (item.status === google.maps.DistanceMatrixStatus.OK) {
                                dealersData[index].distance = item.distance.value * 0.62
                            }
                        })
                        
                        const filteredData = dealersData.filter(item => item.distance/1000 < formData.distance)
                        
                        if (filteredData.length) {
                            renderMap(filteredData)
                        } else {
                            alert(translations.noDealer[lang], 'warning')
                        }
                    } else {
                        alert(translations.noResults[lang], 'warning')
                    }
                } else {
                    alert(translations.wentWrong[lang], 'warning')
                }
            }
        );
    }

    const alertPlaceholder = document.getElementById('liveAlertPlaceholder')
    alertPlaceholder?.firstChild?.remove()
}

export const getDealers = async () => {
    const response = await fetch("/get-dealers", {method: "GET"})
    if (response.status === 200) {
      const result = await response.json()
      dealersData = result
    }
}

export const renderMap = async (filteredData) => {
    const mapBlock = document.querySelector(".map");

    if (mapBlock) {
        mapBlock.innerHTML = ""
    
        if (!filteredData) await getDealers()
    
        const map = new google.maps.Map(
            mapBlock, {
                zoom: 3,
                gestureHandling: "cooperative",
                mapTypeId: google.maps.MapTypeId.ROADMAP
            }
        );
    
        const geocoder = new google.maps.Geocoder();
        const bounds = new google.maps.LatLngBounds();
    
        const data = filteredData || dealersData
    
        data.sort((a, b) => a.distance - b.distance).forEach((dealer) => {
            setMarker(dealer, geocoder, bounds, map)
        })
    }
}

export const dealersForm = () => {
    const dealersBlock = document.createElement('div');
    const mapBlock = document.createElement("div");
    const becomeDealer = document.createElement('div');
    const shopOnline = document.createElement('div');
    const buttonsWrapper = document.createElement('div');

    dealersBlock.classList.add('dealer_block');
    mapBlock.classList.add('map');
    becomeDealer.classList.add('btn', 'become-dealer');
    becomeDealer.id = "getDealerForm";
    shopOnline.classList.add("btn", "shop-online");
    shopOnline.id = "shopOnline";

    becomeDealer.innerText = translations.becomeDealer[lang].toUpperCase();
    shopOnline.innerHTML = translations.shopOnline[lang].toUpperCase();

    dealersBlock.innerHTML = zipForm(lang);
    dealersBlock.appendChild(mapBlock);
    dealersBlock.innerHTML += becomeDealerForm(lang);
    buttonsWrapper.appendChild(becomeDealer);
    buttonsWrapper.appendChild(shopOnline);
    dealersBlock.appendChild(buttonsWrapper);

    return dealersBlock
}

export const becomeDealerLogic = () => {
    const closeModal = document.querySelector(".btn-close")
    const modal = document.querySelector(".become-dealer_form")
    const nextButton = document.querySelector(".dealer-next")
    const previousButton = document.querySelector(".dealer-previous")
    const first = document.querySelector("#firstStep")
    const second = document.querySelector("#secondStep")

    modal && (modal.style.display = "block")
    closeModal && (closeModal.onclick = () => (modal && (modal.style.display = "none")))
    nextButton && (nextButton.onclick = () => {
        first && first.classList.add("hide_block")
        second && second.classList.remove("hide_block")
    })
    previousButton && (previousButton.onclick = () => {
        first && first.classList.remove("hide_block")
        second && second.classList.add("hide_block")
    })
}

export const resetInputs = (event) => {
    event.preventDefault();
    event.target.form.zipCode.value = "";
    event.target.form.country.value = "";
    event.target.form.distance.value = "";
    renderMap();
}